import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { StateService } from "../services/state.service";
import { DomainNavigationService } from "../services/domain-navigation.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  signUp: boolean = false;
  domainType: string = "";

  constructor(
    private router: Router,
    private stateService: StateService,
    private domainNavigationService: DomainNavigationService
  ) {
    this.domainType = this.stateService.checkAppConfig();
  }

  ngOnInit(): void {}

  login() {
    // Get the domain-specific login URL with appropriate redirect
    const loginUrl = this.getLoginUrlWithRedirect();
    window.location.replace(loginUrl);
  }

  private getLoginUrlWithRedirect(): string {
    const baseLoginUrl = this.stateService.apiList.user.login;
    const redirectUrl = this.domainNavigationService.getLoginRedirectUrl();

    // Append redirect parameter to login URL
    const separator = baseLoginUrl.includes("?") ? "&" : "?";
    return `${baseLoginUrl}${separator}redirect=${encodeURIComponent(redirectUrl)}`;
  }

  userBoarding() {
    this.signUp = !this.signUp;
  }
}
